import {Card} from 'antd';
import React from 'react';
import {Route, Switch} from 'react-router';
import EmpresaUnidadesDetailPage from './_detail';
import EmpresaUnidadePage from './unidade';

export default function EmpresaUnidadesPage() {
  return (
      <Card bordered={false}>
        <Switch>
          <Route path="/*/empresas/:empresaId/unidades/:id" component={EmpresaUnidadePage} />
          <Route path="/*/empresas/:empresaId" component={EmpresaUnidadesDetailPage} />
        </Switch>
      </Card>);
}
